import { css } from '@emotion/react';
import { IonButton, IonContent, IonPage } from '@ionic/react';
import React from 'react';
import ErrorPerson from '../../components/ErrorPerson';
import PageHeader from '../../components/PageHeader';
import { Title } from '../../components/Title';
import * as commonCss from '../../styles/common';

export const NotFoundPage: React.FC = () => {
  return (
    <IonPage>
      <PageHeader title="Page Not Found" />
      <IonContent>
        <div css={[commonCss.centered, css({ paddingTop: '1rem' })]}>
          <ErrorPerson title="Oops!" type="shrug">
            <Title level={2}>We couldn&apos;t find what you&apos;re looking for.</Title>
            <br />
            <br />
            <IonButton routerLink="/world">Go to OpenMap</IonButton>
          </ErrorPerson>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default NotFoundPage;
